import "./OurStory.module.css";
import MainNavigation from "@/reusable_sections/Header";
import LocalRootsExpertCare from "./sections/LocalRootsExpertCare";
import TheManagementTeam from "./sections/TheManagementTeam";
import CommunityImpact from "./sections/CommunityImpact";
import SiteFooter from "@/reusable_sections/Footer";
export default function OurStoryPage() {
  return <div>
      <MainNavigation />
      <LocalRootsExpertCare />
      <TheManagementTeam />
      <CommunityImpact />
      <SiteFooter />
    </div>;
}